import { ADD_KEY_SUCCESS, REMOVE_KEY_SUCCESS, REQUEST_KEYS_SUCCESS, UPDATE_KEY_SUCCESS } from '../handlers.actions';
import { IAction } from '../sagas';

const initKeyStore: any = () => ([]);

/** Key reducer */
export const keyReducer = (state =  initKeyStore(), action:IAction) => {
    const {payload, type} = action;
    switch(type){
        case ADD_KEY_SUCCESS:
            return [...state.slice(0, payload), payload, ...state.slice(payload)];
        case UPDATE_KEY_SUCCESS:
            return state.map((key:any) => payload._id === key._id ? payload: key);
        case REMOVE_KEY_SUCCESS:
            return state.filter((key:any) => key._id !== payload._id);
        case REQUEST_KEYS_SUCCESS:
            const merged = [...state, ...payload];
            const set = new Set();
            const unionArray = merged.filter((key:any) => {
                if(set.has(key._id)) return false;
                set.add(key._id);
                return true;
            }, set);
            return [...unionArray];
        default:
            return state;
    }
}